module.exports = __webpack_public_path__ + "static/media/Ausschuss.3a82e857.svg";